<nav>
  <a href="/#/">&larr;</a>
</nav>
<router-outlet></router-outlet>
